import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import type { Role } from '@/types/auth'
import { Forbidden } from './Forbidden'

/** Hard route guard: renders <Forbidden/> when the user's role isn't permitted (§6.3). */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const user = useAuthStore((s) => s.user)
  if (!user) return <Navigate to="/login" replace />
  if (!roles.includes(user.role)) return <Forbidden />
  return <>{children}</>
}
